import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';
import { ModuleMatrix, ModuleModel, ModuleMatrixSearchEvent } from 'src/app/features/modules/module-model';
import { PagedResult } from '../models/paging';
import { OrganizationType } from '../enums/organization-type.enum';

@Injectable({
  providedIn: 'root',
})
export class ModuleService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  private readonly apiURL: string;

  constructor() {
    this.apiURL = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/';
  }

  getModules(): Observable<ModuleModel[]> {
    const url = `${this.apiURL}Module`;
    return this.http.get<ModuleModel[]>(url);
  }

  getModuleMatrix(searchEvent: ModuleMatrixSearchEvent): Observable<PagedResult<ModuleMatrix>> {
    const url = `${this.apiURL}Module/Matrix`;
    let params = new HttpParams();

    if (searchEvent?.organizationId) {
      params = params.append('organizationId', searchEvent.organizationId);
    }

    if (searchEvent?.query) {
      params = params.append('query', searchEvent.query);
    }

    if (searchEvent?.paging?.pageIndex) {
      params = params.append('page', searchEvent.paging.pageIndex);
    }

    if (searchEvent?.paging?.pageSize) {
      params = params.append('pageSize', searchEvent.paging.pageSize);
    }

    if (searchEvent?.sorting?.active) {
      params = params.append('sortby', searchEvent.sorting.active);
    }

    if (searchEvent?.sorting?.direction) {
      params = params.append('sortdirection', searchEvent.sorting.direction);
    }

    return this.http.get<PagedResult<ModuleMatrix>>(url, { params });
  }

  createModuleMatrix(organizationId: number, moduleId: number): Observable<void> {
    const url = `${this.apiURL}Module/${moduleId}/Matrix`;
    return this.http.post<void>(url, {
      organizationId: organizationId,
    });
  }

  deleteModuleMatrix(organizationId: number, moduleId: number): Observable<void> {
    const url = `${this.apiURL}Module/${moduleId}/Matrix/${organizationId}`;
    return this.http.delete<void>(url);
  }

  createModuleMatrices(moduleId: number, organizationType: OrganizationType | null = null): Observable<void> {
    const url = `${this.apiURL}Module/${moduleId}/Matrices`;
    return this.http.post<void>(url, {
      organizationType: organizationType,
    });
  }

  deleteModuleMatrices(moduleId: number): Observable<void> {
    const url = `${this.apiURL}Module/${moduleId}/Matrices`;
    return this.http.delete<void>(url);
  }
}
